import { Card, CardTitle } from 'components/Card/Card';
import { PreviewLabel, PreviewValue } from 'components/PreviewFields/PreviewFields';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useUserStore } from 'stores/user.store';

export const PartnerInfoPreview = () => {
    const partner = useUserStore(state => state.user?.partner);
    const { t } = useTranslation('forms');
    const { t: p } = useTranslation('partner');

    return (
        <Card className="flex-1 flex flex-col gap-8">
            <CardTitle>{p('personalInfo.title')}</CardTitle>

            <div className="flex flex-col gap-6">
                <div className="flex gap-6">
                    <div className="flex-1">
                        <PreviewLabel>{t('firstName')}</PreviewLabel>
                        <PreviewValue>{partner?.firstName}</PreviewValue>
                        {partner?.isSpouse && <span className="text-rose-300 text-sm">{t('spouseLabel')}</span>}
                    </div>
                    <div className="flex-1">
                        <PreviewLabel>{t('lastName')}</PreviewLabel>
                        <PreviewValue>{partner?.lastName}</PreviewValue>
                    </div>
                </div>
                <div className="flex gap-6">
                    <div className="flex-1">
                        <PreviewLabel>{t('salutation')}</PreviewLabel>
                        <PreviewValue>{partner?.salutation ? t(partner.salutation) : '-'}</PreviewValue>
                    </div>
                    <div className="flex-1">
                        <PreviewLabel>{t('dateOfBirth')}</PreviewLabel>
                        <PreviewValue>{dayjs(partner?.dateOfBirth).format('DD.MM.YYYY')}</PreviewValue>
                    </div>
                </div>

                <div className="flex gap-6">
                    <div className="flex-1">
                        <PreviewLabel>{t('company')}</PreviewLabel>
                        <PreviewValue>{partner?.company}</PreviewValue>
                    </div>
                    <div className="flex-1">
                        <PreviewLabel>{t('jobTitle')}</PreviewLabel>
                        <PreviewValue>{partner?.jobTitle}</PreviewValue>
                    </div>
                </div>
            </div>
        </Card>
    );
};
